import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/icon/img-empty.svg'
import _imports_1 from '@/assets/img/modal-confirmation/send-otp.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", null, "Informasi Login", -1)
const _hoisted_2 = { class: "grid md:grid-cols-2 gap-x-5 items-center mt-3" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "label-text required"
}, "Username", -1)
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "label-text required"
}, "Password", -1)
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "label-text required"
}, "Nomor Telepon", -1)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "label-text required",
  for: "email"
}, "Email", -1)
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", null, "Informasi Pribadi", -1)
const _hoisted_16 = { class: "mt-3 flex gap-4 mb-3" }
const _hoisted_17 = {
  key: 0,
  class: "background-grey-3 flex rounded-md wrap-img"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "m-auto" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "mx-auto"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-grey-5 text-xs font-bold" }, "Max. 1MB")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-xl mb-2" }, "Foto Profil", -1)
const _hoisted_24 = { class: "flex gap-4 items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload font-black text-sm" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Upload")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times color-danger text-sm" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "color-danger font-extrabold" }, "Hapus", -1)
const _hoisted_29 = { class: "grid md:grid-cols-2 gap-x-5 items-center" }
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "fullname",
  class: "label-text required"
}, "Nama Lengkap", -1)
const _hoisted_32 = { class: "invalid-feedback" }
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "id-number",
  class: "label-text required"
}, "No. KTP/SIM", -1)
const _hoisted_35 = { class: "invalid-feedback" }
const _hoisted_36 = { class: "mb-4" }
const _hoisted_37 = {
  for: "idcard-number",
  class: "label-text required"
}
const _hoisted_38 = { class: "invalid-feedback" }
const _hoisted_39 = { class: "grid grid-cols-2 gap-x-5" }
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "birth-place",
  class: "label-text required"
}, "Tempat Lahir", -1)
const _hoisted_42 = { class: "invalid-feedback" }
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "birth-date",
  class: "label-text required"
}, "Tanggal Lahir", -1)
const _hoisted_45 = { class: "invalid-feedback" }
const _hoisted_46 = { class: "mb-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: "sex",
  class: "label-text required"
}, "Jenis Kelamin", -1)
const _hoisted_48 = { class: "grid grid-cols-2 gap-x-5" }
const _hoisted_49 = { class: "mb-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "emergency-fullname",
  class: "label-text"
}, "Nama Kontak Darurat", -1)
const _hoisted_51 = { class: "invalid-feedback" }
const _hoisted_52 = { class: "mb-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", {
  for: "emergency-phone",
  class: "label-text"
}, "Telp Kontak Darurat", -1)
const _hoisted_54 = { class: "invalid-feedback" }
const _hoisted_55 = { class: "mb-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  for: "marriage",
  class: "label-text required"
}, "Status Pernikahan", -1)
const _hoisted_57 = { class: "mb-4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", {
  for: "emergency-address",
  class: "label-text"
}, "Alamat Kontak Darurat", -1)
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", {
  for: "nfc-number",
  class: "label-text"
}, "Nomor NFC Tag", -1)
const _hoisted_61 = { class: "input-icon-right nfc-tag" }
const _hoisted_62 = { class: "invalid-feedback" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  for: "address",
  class: "label-text required"
}, "Alamat Domisili", -1)
const _hoisted_64 = { class: "invalid-feedback" }
const _hoisted_65 = { class: "mb-4 mt-4" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h6", null, "Upload Dokumen", -1)
const _hoisted_67 = { class: "mt-3 flex gap-x-2 items-center" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload font-black text-sm" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Upload KTP/SIM ")
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times color-danger text-sm" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", { class: "color-danger font-extrabold" }, "Hapus", -1)
const _hoisted_72 = { class: "mb-4" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_74 = { class: "flex mt-auto" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_76 = { class: "mb-5 px-2" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-send-otp mx-auto mb-5 mt-3",
  src: _imports_1
}, null, -1)
const _hoisted_78 = { class: "px-5" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-center mb-2" }, "Verifikasi OTP", -1)
const _hoisted_80 = { class: "text-center mb-2" }
const _hoisted_81 = { class: "flex justify-center" }
const _hoisted_82 = { class: "rounded-full background-blue-4 flex items-center px-4 py-1" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Kirim dalam", -1)
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_85 = { class: "text-sm font-semibold" }
const _hoisted_86 = { class: "flex justify-center mt-2" }
const _hoisted_87 = { class: "flex justify-center mt-5" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("p", null, "Belum menerima Kode OTP? ", -1)
const _hoisted_89 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ButtonFileUpload = _resolveComponent("ButtonFileUpload")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Card = _resolveComponent("Card")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!

  return (_openBlock(), _createElementBlock("section", null, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _createVNode(_component_Card, { class: "card-no-shadow card-form" }, {
            content: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_Field, { name: "Username" }, {
                      default: _withCtx(({ field, handleChange, handleBlur }) => [
                        _createVNode(_component_InputText, _mergeProps({
                          id: "username",
                          "aria-describedby": "username-help",
                          placeholder: "Masukkan Username"
                        }, field, {
                          onChange: handleChange,
                          onBlur: handleBlur,
                          class: `input-primary ${_ctx.errors.Username ? 'input-invalid' : ''}`,
                          minlength: 5,
                          maxlength: 30,
                          disabled: _ctx.isEdit
                        }), null, 16, ["onChange", "onBlur", "class", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.errors.Username), 1)
                  ]),
                  (!_ctx.isEdit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_Field, { name: "Password" }, {
                          default: _withCtx(({ field, handleChange, handleBlur }) => [
                            _createVNode(_component_Password, _mergeProps({ class: "w-full" }, field, {
                              onChange: handleChange,
                              onBlur: handleBlur,
                              id: "password",
                              feedback: false,
                              placeholder: "********",
                              toggleMask: "",
                              minlength: 8,
                              maxlength: 100,
                              class: `input-primary ${_ctx.errors.Password ? 'input-invalid' : ''}`
                            }), null, 16, ["onChange", "onBlur", "class"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.errors.Password), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_Field, { name: "PhoneNumber" }, {
                      default: _withCtx(({ handleChange, handleBlur, field }) => [
                        _createVNode(_component_InputText, _mergeProps({
                          class: `input-primary ${_ctx.errors.PhoneNumber ? 'input-invalid' : ''}`,
                          id: "phone"
                        }, field, {
                          "aria-describedby": "phone-help",
                          placeholder: "08xx",
                          type: "tel",
                          onChange: handleChange,
                          onBlur: handleBlur,
                          minlength: 10,
                          maxlength: 14
                        }), null, 16, ["class", "onChange", "onBlur"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.errors.PhoneNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_Field, { name: "Email" }, {
                      default: _withCtx(({ handleChange, handleBlur, field }) => [
                        _createVNode(_component_InputText, _mergeProps({
                          class: `input-primary ${_ctx.errors.Email ? 'input-invalid' : ''}`,
                          id: "email"
                        }, field, {
                          "aria-describedby": "email-help",
                          placeholder: "Ex. john@email.com",
                          onChange: handleChange,
                          onBlur: handleBlur,
                          minlength: 1,
                          maxlength: 90
                        }), null, 16, ["class", "onChange", "onBlur"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.errors.Email), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    (!_ctx.values.ProfilePicture && !_ctx.tempImgProfile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                      : (_ctx.values.ProfilePicture?.blob)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.values.ProfilePicture?.blob,
                            class: "wrap-img cursor-pointer",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDetailImg(_ctx.values.ProfilePicture.blob)))
                          }, null, 8, _hoisted_20))
                        : (_ctx.tempImgProfile)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 2,
                              src: _ctx.tempImgProfile.fileUrl,
                              class: "wrap-img cursor-pointer",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDetailImg(_ctx.tempImgProfile.fileUrl)))
                            }, null, 8, _hoisted_21))
                          : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", null, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_ButtonFileUpload, {
                          inputId: "idPhotoProfile",
                          size: _ctx.maxSizeFile,
                          onOnInputFile: _cache[2] || (_cache[2] = (newFile, oldFile) => _ctx.onInputFile(newFile, 'photo-profile', _ctx.setFieldValue))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Button, { class: "btn-back flex gap-x-2" }, {
                              default: _withCtx(() => [
                                _hoisted_25,
                                _hoisted_26
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["size"]),
                        (_ctx.values.ProfilePicture)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              class: "btn-back gap-x-2 flex",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFieldValue('ProfilePicture', null)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_27,
                                _hoisted_28
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_Field, { name: "Fullname" }, {
                      default: _withCtx(({ handleChange, handleBlur, field }) => [
                        _createVNode(_component_InputText, _mergeProps({ id: "fullname" }, field, {
                          "aria-describedby": "fullname-help",
                          class: `input-primary ${_ctx.errors.Fullname ? 'input-invalid' : ''}`,
                          placeholder: "Masukkan Nama Lengkap",
                          onChange: handleChange,
                          onBlur: handleBlur
                        }), null, 16, ["class", "onChange", "onBlur"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.errors.Fullname), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode(_component_Field, { name: "NIK" }, {
                      default: _withCtx(({ handleChange, handleBlur, field }) => [
                        _createVNode(_component_InputText, _mergeProps({
                          id: "id-number",
                          "aria-describedby": "id-number-help",
                          placeholder: "1234xxx",
                          class: `input-primary ${_ctx.errors.NIK ? 'input-invalid' : ''}`
                        }, field, {
                          onChange: handleChange,
                          onBlur: handleBlur,
                          minlength: 16,
                          maxlength: 16
                        }), null, 16, ["class", "onChange", "onBlur"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.errors.NIK), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.role === 'Sopir' || _ctx.role === 'Pembantu' ? 'No. ID Card' : 'Kode Karyawan'), 1),
                    _createVNode(_component_Field, { name: "IdCardNumber" }, {
                      default: _withCtx(({ handleChange, handleBlur, field }) => [
                        _createVNode(_component_InputText, _mergeProps({
                          id: "idcard-number",
                          "aria-describedby": "idcard-number-help",
                          placeholder: "abc1234xxx",
                          type: "text",
                          class: `input-primary ${_ctx.errors.IdCardNumber ? 'input-invalid' : ''}`
                        }, field, {
                          onChange: handleChange,
                          onBlur: handleBlur,
                          maxlength: 10
                        }), null, 16, ["class", "onChange", "onBlur"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.errors.IdCardNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_Field, { name: "PlaceOfBirth" }, {
                        default: _withCtx(({ handleChange, handleBlur, field }) => [
                          _createVNode(_component_InputText, _mergeProps({
                            id: "birth-place",
                            "aria-describedby": "birth-place-help",
                            placeholder: "Kota",
                            class: `input-primary ${_ctx.errors.PlaceOfBirth ? 'input-invalid' : ''}`
                          }, field, {
                            onChange: handleChange,
                            onBlur: handleBlur,
                            maxlength: 30
                          }), null, 16, ["class", "onChange", "onBlur"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.errors.PlaceOfBirth), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_Field, { name: "DateOfBirth" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_DatePicker, _mergeProps(field, {
                            modelValue: _ctx.values.DateOfBirth,
                            "onUpdate:modelValue": [
                              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.values.DateOfBirth) = $event)),
                              _cache[5] || (_cache[5] = (val) => _ctx.setFieldValue('DateOfBirth', val))
                            ],
                            masks: {
                        input: 'DD/MM/YYYY'
                      },
                            "max-date": new Date()
                          }), {
                            default: _withCtx(({ togglePopover, inputValue }) => [
                              _createVNode(_component_InputText, {
                                id: "birth-date",
                                "aria-describedby": "birth-date-help",
                                placeholder: "DD/MM/YYYY",
                                value: inputValue,
                                class: _normalizeClass(`input-primary ${_ctx.errors.DateOfBirth ? 'input-invalid' : ''}`),
                                onClick: togglePopover,
                                readonly: ""
                              }, null, 8, ["value", "class", "onClick"])
                            ]),
                            _: 2
                          }, 1040, ["modelValue", "max-date"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.errors.DateOfBirth), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_Field, { name: "Sex" }, {
                      default: _withCtx(({ handleBlur }) => [
                        _createVNode(_component_Dropdown, {
                          optionLabel: "label",
                          optionValue: "value",
                          id: "sex",
                          options: _ctx.optionGender,
                          placeholder: "Pilih Jenis Kelamin",
                          class: "w-full input-primary",
                          onBlur: handleBlur,
                          onChange: _cache[6] || (_cache[6] = (val) => _ctx.setFieldValue('Sex', val.value)),
                          modelValue: _ctx.values.Sex,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.values.Sex) = $event))
                        }, null, 8, ["options", "onBlur", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createVNode(_component_Field, { name: "EmergencyContact" }, {
                        default: _withCtx(({ handleChange, handleBlur, field }) => [
                          _createVNode(_component_InputText, _mergeProps({
                            id: "emergency-fullname",
                            "aria-describedby": "emergency-fullname-help",
                            placeholder: "Nama Kontak",
                            class: `input-primary ${_ctx.errors.EmergencyContact ? 'input-invalid' : ''}`
                          }, field, {
                            onChange: handleChange,
                            onBlur: handleBlur,
                            maxlength: 30
                          }), null, 16, ["class", "onChange", "onBlur"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.errors.EmergencyContact), 1)
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_Field, { name: "EmergencyPhone" }, {
                        default: _withCtx(({ handleChange, handleBlur, field }) => [
                          _createVNode(_component_InputText, _mergeProps({
                            id: "emergency-phone",
                            "aria-describedby": "emergency-phone-help",
                            placeholder: "08xx",
                            class: `input-primary ${_ctx.errors.EmergencyPhone ? 'input-invalid' : ''}`
                          }, field, {
                            onChange: handleChange,
                            onBlur: handleBlur,
                            minlength: 10,
                            maxlength: 14
                          }), null, 16, ["class", "onChange", "onBlur"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.errors.EmergencyPhone), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createVNode(_component_Field, { name: "MaritalStatus" }, {
                      default: _withCtx(({ handleBlur }) => [
                        _createVNode(_component_Dropdown, {
                          optionLabel: "label",
                          optionValue: "value",
                          id: "marriage",
                          options: _ctx.maritalStatusOption,
                          placeholder: "Pilih Status Pernikahan",
                          class: "w-full input-primary",
                          onBlur: handleBlur,
                          onChange: _cache[8] || (_cache[8] = (val) => _ctx.setFieldValue('MaritalStatus', val.value)),
                          modelValue: _ctx.values.MaritalStatus,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.values.MaritalStatus) = $event))
                        }, null, 8, ["options", "onBlur", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode(_component_Field, {
                      name: "EmergencyAddress",
                      as: "textarea",
                      placeholder: "Ex. jl. panjang blok Q",
                      class: "input-primary"
                    }, {
                      default: _withCtx(({ handleChange, handleBlur }) => [
                        _createVNode(_component_Textarea, {
                          maxlength: 400,
                          id: "emergency-address",
                          "aria-describedby": "emergency-address-help",
                          autoResize: true,
                          rows: "3",
                          onChange: handleChange,
                          onBlur: handleBlur
                        }, null, 8, ["onChange", "onBlur"])
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.role === 'Kontroler')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _hoisted_60,
                        _createVNode(_component_Field, { name: "NfcTag" }, {
                          default: _withCtx(({ handleChange, handleBlur, field }) => [
                            _createElementVNode("div", _hoisted_61, [
                              _createVNode(_component_InputText, _mergeProps({
                                id: "nfc-number",
                                "aria-describedby": "nfc-number-help",
                                placeholder: "123xxx",
                                class: `input-primary ${_ctx.errors.NfcTag ? 'input-invalid' : ''}`
                              }, field, {
                                modelValue: _ctx.values.NfcTag,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.values.NfcTag) = $event)),
                                onInput: _ctx.handleNfcInput,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                readonly: false,
                                onKeyup: _withKeys(_ctx.handleNfcEnter, ["enter"])
                              }), null, 16, ["class", "modelValue", "onInput", "onChange", "onBlur", "onKeyup"]),
                              _createVNode(_component_InlineSvg, {
                                src: require('@/assets/img/icon/nfc-outline-black.svg')
                              }, null, 8, ["src"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.errors.NfcTag), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _hoisted_63,
                    _createVNode(_component_Field, {
                      id: "address",
                      name: "Address",
                      as: "textarea",
                      type: "text",
                      placeholder: "Ex. jl. panjang blok Q",
                      class: _normalizeClass(`input-primary ${_ctx.errors.Address ? 'input-invalid' : ''}`),
                      modelValue: _ctx.values.Address,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.values.Address) = $event)),
                      validateOnInput: true
                    }, null, 8, ["class", "modelValue"]),
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.errors.Address), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createElementVNode("div", _hoisted_67, [
                  (_ctx.values.NIKPicture?.blob)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "font-semibold cursor-pointer",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openDetailImg(_ctx.values.NIKPicture?.blob)))
                      }, _toDisplayString(_ctx.values.NIKPicture?.name), 1))
                    : (_ctx.tempImgNikPicture)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 1,
                          class: "font-semibold cursor-pointer",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openDetailImg(_ctx.tempImgNikPicture?.fileUrl)))
                        }, _toDisplayString(_ctx.tempImgNikPicture?.fileName), 1))
                      : _createCommentVNode("", true),
                  _createVNode(_component_ButtonFileUpload, {
                    inputId: "idFileKtp",
                    size: _ctx.maxSizeFile,
                    onOnInputFile: _cache[14] || (_cache[14] = (newFile, oldFile) => _ctx.onInputFile(newFile, 'ktp/sim', _ctx.setFieldValue))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Button, { class: "btn-back flex gap-x-2" }, {
                        default: _withCtx(() => [
                          _hoisted_68,
                          _hoisted_69
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["size"]),
                  (_ctx.values.NIKPicture)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 2,
                        class: "btn-back gap-x-2 flex",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setFieldValue('NIKPicture', null)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_70,
                          _hoisted_71
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createVNode(_component_Field, { name: "IsActive" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_InputSwitch, _mergeProps({ class: "input-success" }, field, {
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      inputId: "isactive"
                    }), null, 16, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_74, [
                _createVNode(_component_Button, {
                  class: "btn-back mr-2",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onBack()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_75
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  type: "submit",
                  class: "btn-primary mr-1",
                  disabled: (_ctx.meta.valid && false)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Simpan " + _toDisplayString(_ctx.role), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          })
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalDefault, {
      show: _ctx.showDialogOtp,
      onHideDialog: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showDialogOtp = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_76, [
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            _hoisted_79,
            _createElementVNode("p", _hoisted_80, "Kami akan mengirimkan Whatsapp berupa kode OTP ke nomor " + _toDisplayString(_ctx.dataForm?.PhoneNumber), 1),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _hoisted_83,
                _hoisted_84,
                _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.secondsLeft) + " Detik", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createVNode(_component_v_otp_input, {
                ref: "otpInput",
                value: _ctx.otpInputValue,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.otpInputValue) = $event)),
                "input-classes": "otp-input-user",
                "num-inputs": 6,
                "should-auto-focus": true,
                "input-type": "number",
                placeholder: ['', '', '', '', '', ''],
                separator: "",
                onOnComplete: _ctx.onCompleteOtp
              }, null, 8, ["value", "onOnComplete"])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _hoisted_88,
              _createElementVNode("p", {
                class: _normalizeClass(`font-extrabold ${_ctx.secondsLeft === 0 ? 'cursor-pointer text-primary' : ''}`),
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.secondsLeft === 0 ? _ctx.getTokenOtp(true) : null))
              }, "Kirim Ulang", 2)
            ]),
            _createVNode(_component_Button, {
              class: "btn-primary w-full mt-5",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.submitOtp()))
            }, {
              default: _withCtx(() => [
                _hoisted_89
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_HjpConfirmationModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}